<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><strong>TERRORISM AS CRIME</strong></p>
<p class="center"><a id="page_ii"></a><span class="smallcaps">ALTERNATIVE CRIMINOLOGY SERIES</span><br/><em>General Editor:</em> Jeff Ferrell</p>
<p class="center1"><em>Pissing on Demand<br/>Workplace Drug Testing and the Rise of the Detox Industry</em><br/>Ken Tunnell</p>
<p class="center1"><em>Empire of Scrounge<br/>Inside the Urban Underground of Dumpster Diving, Trash Picking, and<br/>Street Scavenging</em><br/>Jeff Ferrell</p>
<p class="center1"><em>Prison, Inc.<br/>A Convict Exposes Life inside a Private Prison</em><br/>K. C. Carceral, edited by Thomas J. Bernard</p>
<p class="center1"><em>Terrorism as Crime<br/>From Oklahoma City to Al-Qaeda and Beyond</em><br/>Mark S. Hamm</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?01f06ad3